import {create} from "zustand";
import {derivedRemoteStore} from "./DerivedStore";
import {Desk, DeskRef, EmployeeRef} from "./Model";
import {getOrSet} from "../util/MapUtil";
import {useDeskStore} from "./DeskStore";
import {emptyArray} from "../util/FunctionUtil";
import {Opt} from "../util/Optional";

export class AssignedDesks {
    private readonly assignedDesks = new Map<EmployeeRef['id'], Desk[]>();
    private readonly deskAssignee = new Map<Desk['id'], EmployeeRef>();

    constructor(
        desks: Desk[],
        deskAssignee: (desk: Desk) => Opt<EmployeeRef> = desk => desk.assignedTo,
    ) {
        desks.forEach(desk => {
            const assignee = deskAssignee(desk);
            if (assignee) {
                getOrSet(this.assignedDesks, assignee.id, emptyArray).push(desk);
                this.deskAssignee.set(desk.id, assignee);
            }
        });
    }

    desksOf(employee: EmployeeRef): Desk[] {
        return this.assignedDesks.get(employee.id) || [];
    }

    assigneeOf(desk: DeskRef): Opt<EmployeeRef> {
        return this.deskAssignee.get(desk.id);
    }

    static EMPTY = new AssignedDesks([]);
}

export const useAssignedDeskStore = create(
    derivedRemoteStore(
        {desks: useDeskStore},
        ({desks}) => new AssignedDesks(desks),
    )
);